import { render, staticRenderFns } from "./MarketSales.vue?vue&type=template&id=ba634cce&scoped=true&"
import script from "./MarketSales.vue?vue&type=script&lang=js&"
export * from "./MarketSales.vue?vue&type=script&lang=js&"
import style0 from "./MarketSales.vue?vue&type=style&index=0&id=ba634cce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba634cce",
  null
  
)

export default component.exports